import React from "react";

/**
 * Same path always.
 * - default: outline
 * - active: thicker red outline (row favourite)
 * - filled: solid red fill (top “show favourites” filter on)
 */
export default function HeartIcon({
  active = false,
  filled = false,
  size = 14,
}) {
  const emphasize = active || filled;
  return (
    <svg
      className={`v2-heart-icon${emphasize ? " v2-heart-icon--active" : ""}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden
      focusable="false"
    >
      <path
        d="M12 21s-6.7-4.35-9.33-8.5C.8 9.4 1.9 5.8 5.1 4.6c1.7-.6 3.5-.2 4.7 1.1L12 8l2.2-2.3c1.2-1.3 3-1.7 4.7-1.1 3.2 1.2 4.3 4.8 2.43 7.9C18.7 16.65 12 21 12 21z"
        fill={filled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth={emphasize ? 2.6 : 1.8}
        strokeLinejoin="round"
      />
    </svg>
  );
}
